import * as React from "react";
import * as Ons from "react-onsenui";
import { API } from "../API";
import { isLoading, Loading, loading } from "../Loading";
import { AgencyId } from "../messages";
import { CaregiverDocumentTypeId } from "../messages/ObjectIds";
import { PassportDocumentCategory, PassportDocumentType } from "../messages/UploadedDocuments";
import { OrientationLanguages, TranslationMapping } from "../messages/Video";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { ScreenSkeleton } from "./ScreenSkeleton";

export interface MedflytPassportCategoryProps {
  api: API;
  onBackClick: () => void;
  onDocumentTypeClick: (agencyId: AgencyId | null, documentType: PassportDocumentType) => void;
  category: PassportDocumentCategory;
  language: OrientationLanguages;
}

export interface MedflytPassportCategoryState {
  documents: PassportDocumentType[] | Loading;
}

export class MedflytPassportCategoryScreen extends React.PureComponent<
  MedflytPassportCategoryProps,
  MedflytPassportCategoryState
> {
  constructor(props: MedflytPassportCategoryProps) {
    super(props);
    this.state = {
      documents: loading(),
    };

    this.loadDocuments();
  }

  loadDocuments() {
    this.props.api.getMedflytPassportDocumentTypes(this.props.category.id).then((documents) => {
      this.setState({ documents: documents.documents });
    });
  }

  getTranslatedString = (
    stringMap: TranslationMapping<string>,
    language: OrientationLanguages
  ): string => {
    const defaultLang: OrientationLanguages = "English";

    let labelTranslation = stringMap[language];

    if (labelTranslation === undefined) {
      labelTranslation = stringMap[defaultLang];
    }

    return labelTranslation as string;
  };

  render() {
    return (
      <ScreenSkeleton
        className="MedflytPassportCategoryScreen"
        rootClassName="UploadDocFilesScreen_background"
        title={this.getTranslatedString(this.props.category.name, this.props.language)}
        titleBarStyle={ScreenSkeleton.TitleBarStyle.PRIMARY}
        onBackClick={this.props.onBackClick}
      >
        {isLoading(this.state.documents) ? (
          <div className="VisitsScreen__loadingCont">
            <Ons.ProgressCircular indeterminate={true} />
            <div>{translate(STRINGS.LOADING)}...</div>
          </div>
        ) : (
          <div className="MedflytPassportCategoryScreen">
            {this.state.documents.map((curr) => (
              <div
                key={CaregiverDocumentTypeId.unwrap(curr.id)}
                className="MedflytPassportCategoryScreen_listItem"
                onClick={() => this.props.onDocumentTypeClick(null, curr)}
              >
                <span className="MedflytPassportCategoryScreen_listItemText">
                  {this.getTranslatedString(curr.documentName, this.props.language)}
                </span>
                <img
                  className="MedflytPassportCategoryScreen_listItemArrow"
                  src="assets/new-arrow-right.svg"
                />
              </div>
            ))}
          </div>
        )}
      </ScreenSkeleton>
    );
  }
}
